import React from "react";
import { Badge } from "reactstrap";

export function StatusBadgeInsurance({ status }) {
	switch (Number(status)) {
		case 1:
			return (
				<Badge className="w-50" color="info">
					HABILITANDO
				</Badge>
			);
		case 2:
			return (
				<Badge className="w-50" color="success">
					ATIVO
				</Badge>
			);
		case 3:
			return (
				<Badge className="w-50" color="danger">
					INATIVO
				</Badge>
			);
		case 4:
			return (
				<Badge className="w-50" color="dark">
					NÃO OPTANTE
				</Badge>
			);
		case 5:
			return (
				<Badge className="w-50" color="danger">
					REJEITADO
				</Badge>
			);
		default:
			return (
				<Badge className="w-50" color="secondary">
					PENDENTE
				</Badge>
			);
	}
}
